import { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Notfound, Loading } from '@/components';
import { routeConfig as HomeRouter } from '@/views/home/route.config';
import { routeConfig as SubmitInquiry } from '@/views/submit-inquiry/route.config';
// import Home from './views/home/index';
import Home from './views/homePage/index';
import { routeConfig as Register } from '@/views/register/route.config';
import { routeConfig as ProductList } from '@/views/productList/route.config';
import { routeConfig as LoginIn } from '@/views/loginIn/route.config';
import { routeConfig as Cart } from '@/views/cart/router';
import { routeConfig as HomePage } from '@/views/homePage/route.config';
import { routeConfig as SubmitInquirys } from '@/views/submitInquiry/route.config';
import { routeConfig as ModifyPassword } from '@/views/modifyPassword/route.config';
import { routeConfig as personalCenterRoutes } from '@/views/personal-center/router';
import { routeConfig as industrialDictionary } from '@/views/industrialDictionary/router';
import { routeConfig as ProductDetail } from '@/views/productDetail/route.config';
import { routeConfig as QuickOrder } from '@/views/quick-ordering/route.config';
import { routeConfig as BrandList } from '@/views/brand-list/route.config';
import { routeConfig as productInformation } from '@/views/product-information/router';
import { routeConfig as selectionService } from '@/views/slection-service/route.config';
import { routeConfig as industrycases } from '@/views/industry-cases/router';
import { routeConfig as FrontPageBannerURL } from '@/views/frongBannerURL/route.config';
import { routeConfig as Sustainable} from '@/views/sustainable/router.config';
import { routeConfig as Mobile} from '@/views/phone/route.config';
import { routeConfig as Engagement} from '@/views/engagement/router.config';
import { routeConfig as DeveloperGuide} from '@/views/developer-guide/route.config';
import Layout from '@/layout';

import type { IRouterConfig } from '@/types';

const routeConfigs: IRouterConfig[] = [
  ...HomeRouter,
  ...Register,
  ...ProductList,
  ...HomePage,
  ...LoginIn,
  ...Cart,
  ...SubmitInquiry,
  ...SubmitInquirys,
  ...ModifyPassword,
  ...personalCenterRoutes,
  ...ProductDetail,
  ...QuickOrder,
  ...industrialDictionary,
  ...BrandList,
  ...productInformation,
  ...selectionService,
  ...industrycases,
  ...FrontPageBannerURL,
  ...Sustainable,
  ...Mobile,
  ...Engagement,
  ...DeveloperGuide,
];
/** 全局 router 注册入口 */
const RootRouterConfig = () => {
  // useEffect(() => {
  //   const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  //   if(isMobile){
  //     window.location.href = 'https://www.zydmall.com/center/order/shareOrder.html?id=6336f92ffbf94e129aee66e3e680f1aa';
  //   }
  // }, []);
  return (
    <>
      <BrowserRouter>
        <Suspense fallback={<Loading type="full" />}>
          <Routes>
            <Route key="index" path="/" element={<Home />} />

            <Route path="/" element={<Layout />}>
              {routeConfigs.map(({ path, element: Component, subChildren, ...rest }) => {
                return (
                  <Route key={path} path={path} element={Component} {...(rest as any)}>
                    {subChildren &&
                      subChildren.map(subChild => <Route key={subChild.path} {...subChild} />)}
                  </Route>
                );
              })}
            </Route>

            <Route key="notfound" path="*" element={<Notfound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
};

export default RootRouterConfig;
